import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import {setStore} from "trim-redux";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import List from "@material-ui/core/List/List";
import SubTitle from "../../../../components/elements/SubTitle";
import AddBrandButton from "./AddBrandButton";
import Typography from "@material-ui/core/Typography/Typography";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import Chip from "@material-ui/core/Chip/Chip";
import {Translate} from "../../../../../config/Translate";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import IconButton from "@material-ui/core/IconButton/IconButton";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import TextField from "@material-ui/core/TextField/TextField";

class BrandChooser extends React.Component {
    constructor(props){
        super(props);
        this.timeout =  0;
    }
    classes = this.props.classes;
    state={
        brands:[],
        brand:this.props.initial,
        loading: true,
        search:'',

    }
    componentDidMount(){
        this.setState({
            brand:this.props.initial
        })
        this.loadData()
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        let {search} = this.state;

        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/brands/getAllForChooser${!!search ? "/"+search : ''}`, config)
                .then(response => {
                    this.setState({
                        brands: response.data,
                        loading:false,
                    })

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    async handleChangeSearch(e){
        let text = e.target.value;
        await this.setState({
            search:text
        })
    }
    async handleSearch(){
        if(this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(async() => {
            await this.setState({
                loading:true
            });
            await this.loadData();
        }, 1000);

    }
    handleChangeBrand(item){
        let {brand} = this.state;
        if(brand !== item.id){
            this.setState({
                brand:item.id,
            });
            this.props.changeBrand(item.id);

        }else{
            this.setState({
                brand:null
            });
            this.props.changeBrand(null);

        }

    }
    handleDelete(){
        this.setState({
            brand:null
        });
        this.props.changeBrand(null);

    }
    render(){
        let {brands,loading,brand} = this.state;
        let {title,required,error} = this.props;
        return(
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SubTitle align="left">{title} {!!required ? "*" : ''}</SubTitle>
                </Grid>
                {
                    (!!brands && !!brand) &&
                    <>
                        {
                            brands.map((item,index) => (
                                <>
                                    {
                                        (item.id === brand) &&
                                        <Chip
                                            label={item.name}
                                            style={{marginLeft:5,marginBottom:5}}
                                            onDelete={() => this.handleDelete()}
                                        />
                                    }
                                </>
                            ))
                        }
                    </>

                }
                <Grid item xs={12}>
                    <TextField
                        label= {Translate.search}
                        fullWidth
                        size="small"
                        margin="normal"
                        variant="outlined"
                        name="search"
                        placeholder={Translate.writerHelper}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {
                                        loading ?
                                            <CircularProgress size={22}/> :
                                            <IconButton size="small">
                                                <SearchRoundedIcon color="primary"/>
                                            </IconButton>
                                    }
                                </InputAdornment>
                            ),
                        }}
                        onKeyUp={() => this.handleSearch()}
                        onChange={this.handleChangeSearch.bind(this)}

                    />
                    {
                        loading ? null :
                            <List dense style={{maxHeight:240,overflowY:'auto'}}>
                                {
                                    !!brands &&
                                    brands.map((item,index) => (
                                        <ListItem
                                            key={index}
                                            button
                                            onClick={() => this.handleChangeBrand(item)}
                                        >
                                            <ListItemIcon>
                                                <ChevronLeftRoundedIcon />
                                            </ListItemIcon>
                                            <ListItemText primary={item.name} />
                                            <ListItemSecondaryAction>
                                                <Checkbox
                                                    edge="end"
                                                    onChange={() => this.handleChangeBrand(item)}
                                                    checked={brand === item.id}
                                                />
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))
                                }

                            </List>

                    }
                </Grid>
                <Grid item xs={12}>
                    <AddBrandButton reload={() => this.loadData()}/>
                </Grid>
                {
                    error &&
                        <Typography class="error-text">{error}</Typography>
                }
            </Grid>
        )

    }
}
export default withStyles(Styles)(BrandChooser);